/* CUSTOM product-media-align — bindet das Media-Overlay (Toggle links / Nummer-Nav rechts)
   an die tatsächliche, zentrierte Bild-Box (.product-media-container) statt an den breiteren
   Peek-Slide. Sonst sitzt der Toggle in der Letterbox-Rinne neben dem Bild. Nur Desktop;
   auf Mobil laufen die Overlays ohnehin als statischer Block unter dem Bild. */
(function () {
  function align() {
    var desktop = window.innerWidth >= 750;
    document.querySelectorAll('.product__media-overlays').forEach(function (ov) {
      var parent = ov.offsetParent;
      var box = (parent || document).querySelector('.product-media-container');
      if (!desktop || !box || !parent) {
        ov.style.left = ''; ov.style.right = ''; ov.style.width = '';
        return;
      }
      var br = box.getBoundingClientRect();
      var pr = parent.getBoundingClientRect();
      if (!br.width) { ov.style.left = ''; ov.style.right = ''; ov.style.width = ''; return; }
      ov.style.left = Math.round(br.left - pr.left) + 'px';
      ov.style.right = 'auto';
      ov.style.width = Math.round(br.width) + 'px';
    });
  }

  var raf;
  function onResize() { cancelAnimationFrame(raf); raf = requestAnimationFrame(align); }

  if (document.readyState !== 'loading') align();
  document.addEventListener('DOMContentLoaded', align);
  window.addEventListener('load', align);
  window.addEventListener('resize', onResize);
})();
